import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import GradientButton from 'components/common/GradientButton'
import MailIcon from '@material-ui/icons/Mail'
import useForm from 'hooks/useForm'
import api from 'utils/api'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(theme => ({
	leftIcon: {
		fontSize: 20,
		marginRight: theme.spacing(1),
	},
}))

function MessageForm() {
	const classes = useStyles()
	const { enqueueSnackbar } = useSnackbar()

	const { values, errors, isSubmitting, setIsSubmitting, handleSubmit, handleChange, handleReset } = useForm(
		{ message: '' },
		onSubmit,
		validate
	)

	async function onSubmit() {
		try {
			const { data } = await api.post('/api/message.php', { ...values, type: 'message' })
			handleReset()
			enqueueSnackbar(data.message, { variant: 'success' })
		} catch (e) {
			enqueueSnackbar(e.response.data.message || '메시지를 전송하지 못했습니다.', { variant: 'error' })
		} finally {
			setIsSubmitting(false)
		}
	}

	function validate(values) {
		let errors = {}
		if (!values.message.trim()) {
			errors.message = '메시지를 입력하세요'
		}
		return errors
	}

	return (
		<form onSubmit={handleSubmit} noValidate>
			<TextField
				label="메시지"
				placeholder="입력..."
				multiline
				rows="3"
				fullWidth
				margin="normal"
				variant="outlined"
				InputLabelProps={{ shrink: true }}
				name="message"
				helperText={errors.message}
				value={values.message}
				error={!!errors.message}
				onChange={handleChange}
			/>
			<GradientButton type="submit" variant="contained" color="secondary" disabled={isSubmitting}>
				<MailIcon className={classes.leftIcon} />
				메시지 전송
			</GradientButton>
		</form>
	)
}

export default MessageForm
